import { requestJSON } from '@/lib/api/api';
import { useQuery } from '@tanstack/react-query';
import * as React from 'react';

export interface VenueSearchResult {
  id?: string;
  name: string;
  address?: string;
  lat?: number;
  lng?: number;
  category?: string;
  is_verified?: boolean;
  logo_url?: string;
  claimed?: boolean;
}

interface VenueSearchResponse {
  venues: VenueSearchResult[];
  source: string;
}

const venueSearchKeys = {
  all: ['venue-search'] as const,
  list: (query: string) => [...venueSearchKeys.all, query] as const,
};

export function useVenueSearch(query: string, enabled: boolean, limit = 8) {
  const trimmedQuery = query.trim();
  const [debouncedQuery, setDebouncedQuery] = React.useState(trimmedQuery);

  React.useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedQuery(trimmedQuery);
    }, 250);

    return () => clearTimeout(timeoutId);
  }, [trimmedQuery]);

  return useQuery({
    queryKey: venueSearchKeys.list(debouncedQuery),
    enabled: enabled && debouncedQuery.length >= 2,
    queryFn: () =>
      requestJSON<VenueSearchResponse>(
        `/venues/search?q=${encodeURIComponent(debouncedQuery)}&limit=${limit}`
      ),
    staleTime: 60_000,
  });
}
